<div class="title-bar-container" [ngClass]="{ 'logged-in': userAccountFeatureEnabled }">
    <div class="header-content">
        <h1 qa="requestAppt" class="main-title">
            {{ isRescheduleAppointment ? 'Reschedule Appointment' : 'Request Appointment' }}
        </h1>
        <h3 qa="businessName" class="subtitle">{{ businessName }}</h3>
    </div>
    <a *ngIf="userAccountFeatureEnabled && !userLoggedIn" (click)="onClickLogIn()" class="login-link" id="log-in-link">Log In</a>
    <a *ngIf="userAccountFeatureEnabled && userLoggedIn" (click)="onClickAccount()" class="login-link" id="account-link">Account</a>
</div>
